import { useState } from 'react'

/** A collapsed card keeps its draft mounted until the operator resolves it. */
export default function SetupEditReview({ review, onKeepEditing }) {
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState(null)
  const save = async () => {
    if (saving) return
    setSaving(true)
    setError(null)
    try {
      const result = await review.save()
      if (!result?.ok) setError(result?.error || 'Changes were not saved. Please retry.')
    } catch (cause) {
      setError(cause?.message || 'Changes were not saved. Please retry.')
    } finally {
      setSaving(false)
    }
  }
  return (
    <div role="region" aria-label="Unsaved setup changes" className="rounded-b-lg border border-border bg-canvas p-3 space-y-2 font-mono text-[11px]">
      <div className="font-semibold text-ink">Save changes?</div>
      <ul className="space-y-1 text-inkMuted">
        {review.changes.map(change => <li key={change}>{change}</li>)}
      </ul>
      {error && <div role="alert" className="text-ember">{error}</div>}
      <div className="flex flex-wrap gap-2">
        <button disabled={saving} onClick={save} className="rounded border border-forest/40 px-2 py-1 text-forest disabled:opacity-50">{saving ? 'Saving…' : 'Save changes'}</button>
        <button disabled={saving} onClick={review.discard} className="rounded border border-border px-2 py-1 text-inkMuted disabled:opacity-50">Discard changes</button>
        <button disabled={saving} onClick={onKeepEditing} className="rounded border border-border px-2 py-1 text-inkMuted disabled:opacity-50">Keep editing</button>
      </div>
    </div>
  )
}
